export const isiOS = () => {
  if (typeof window === 'undefined') return false;

  const userAgent = navigator.userAgent || '';

  return /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
};
